export default "__VITE_ASSET__Cbo87LMP__"